module.exports = __webpack_public_path__ + "img/question-diamond.09bbe69e.svg";